
export default {
    nivel: {
        descricao: ''
    },
    niveis: []
}